module.exports = __webpack_public_path__ + "img/img-search08.b275123c.jpg";